import { useState } from 'react';
import Header from './Header';
import { Post,RegisterURL } from '../utils/api';
import { useNavigate,Link } from 'react-router-dom';

const Signin = () => {
    const navigate = useNavigate();

    const [name,setname] = useState('');
    const [mobile,setmobile] = useState('');
    const [password,setPassword] = useState('');

    const [error,setError] = useState({
        name:'',
        mobile:'',
        password:'',
    });

    const validation = () =>{
        let error = {};
        if(name == '') {
            error = {
                name:'Please Enter Name'
            }
            setError(error);
            return false;
        } else if(mobile == '') {
            error = {
                mobile:'Please Enter Mobile Number'
            }
            setError(error);
            return false;
        } else if(password == '') {
            error = {
                password:'Please Enter Password'
            }
            setError(error);
            return false;
        } else {
            return true;
        }
    }

    
    const Signin = () =>{
        if(validation()) {
            global.Loader(true)
            let config = {
                body:{name:name,mobile:mobile,password:password},
                url:RegisterURL
            }
            Post(config).then((res)=>{
                global.Loader(false)
                if(res.status == true) {
                    navigate(`/home`);
                }
            }).catch((err)=>{
                global.Loader(false)

                console.log(err);
            })
        }
    }

    return (
        <div className="best">
            <Header />
            <div className="bredcrub">
            <div className="container">
                <ul>
                    <li><a href="#">Home</a></li>
                    <li style={{paddingLeft:5}}> Sign In</li>
                </ul>
            </div>
        </div>

        <div className="wrapbox">
            <div className="wrapper">
                <div className="heading">
                    <h5>Sign in with</h5>
                </div>
                <div className="social">
                    <a href="#" className="social-links"><img src="/images/search.png"/> Google</a>
                    <a href="#" className="social-links"><img src="/images/facebook.png"/> Facebook</a>
                </div>
                <form className="form-group">
                    <p className="account-heading">or</p>
                    <input type="text" onChange={({target})=>{
                        setname(target.value)
                    }} placeholder="name" className="passwordbox widthset" />
                    <div>
                        <p style={{color:'red'}}>{error?.name}</p>
                    </div>
                    <input type="text" onChange={({target})=>{
                        setmobile(target.value)
                    }} placeholder="mobile" className="passwordbox widthset" />
                    <div>
                        <p style={{color:'red'}}>{error?.mobile}</p>
                    </div>
                    <input type="password" onChange={({target})=>{
                        setPassword(target.value)
                    }} placeholder="Password" className="passwordbox widthset" />
                    <div>
                        <p style={{color:'red'}}>{error?.password}</p>
                    </div>
                </form>
                <div className="signbtnarea">
                        <button className="singinone">
                            <span className="btn btn-primary signinbtn signbtnspace"><i>BACK</i></span>
                        </button>

                        <button onClick={()=>{
                            Signin();
                        }} className="singintwo">
                            <span className="btn btn-primary signinbtn signbtnspacee"><i>Sign In</i></span>
                        </button>

                    </div>
                
                <p className="signinparathree"><Link>Terms & Conditions</Link></p>
            </div>
        </div>
        </div>
    );
};
  
export default Signin;